import { connect } from 'react-redux';
import { CircularProgress, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'inherit',
  },
});

const UniLoader = ({ classes, isSwitcherOpen, loaderDarkTheme, size }) => {
  const darkLoader = loaderDarkTheme || !isSwitcherOpen;

  return (
    <div className={classes.container}>
      {darkLoader ? (
        <CircularProgress size={size} />
      ) : (
        <CircularProgress size={size} style={{ color: 'white' }} />
      )}
    </div>
  );
};

const mapState = (state) => {
  return {
    loaderDarkTheme: state.loaderDarkTheme,
    isSwitcherOpen: state.switcher.isSwitcherOpen,
  };
};

export default connect(mapState)(withStyles(styles)(UniLoader));
